import React, { useImperativeHandle, forwardRef } from "react";

import { useSelector } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import { Paper, Grid, Typography } from "@material-ui/core";

import HorizontalAssetList from "../../Shared/AssetPreviewList/HorizontalAssetList";
import CreativeNameManager from "../../CreativeNameGenerator/CreativeNameManager";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    // border: "1px solid rgba(0, 0, 0, 0.26)",
    boxShadow: "none",
    display: "flex",
    justifyContent: "space-around"
  },
  paper2: {
    padding: 0,
    textAlign: "center",
    color: theme.palette.text.secondary,
    border: "none",
    boxShadow: "none",
    display: "flex",
    justifyContent: "space-around"
  },
  thumbsContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    width: "100%"
  },
  h6: {
    fontWeight: 400,
    fontSize: "1.15rem"
  }
}));

let RMTypes = [
  "RICH_MEDIA_DISPLAY_BANNER",
  "RICH_MEDIA_DISPLAY_EXPANDING",
  "RICH_MEDIA_DISPLAY_INTERSTITIAL"
];

export default forwardRef(
  (
    {
      isClickEnabled,
      isDragDisabled,
      isThumbnailEnabled,
      advertiserId,
      // Opt-in: only Smart Traffic groups its naming list by dimension. The
      // other steppers upload one size at a time, so headers would just add
      // chrome.
      groupByDimension
    },
    ref
  ) => {
    const classes = useStyles();

    let creatives = useSelector((state) => state.creatives);

    useImperativeHandle(ref, () => ({
      // Deliberately more permissive than utils/creativeReadiness, which
      // drives the card's green check: that requires a landing page from
      // every display creative, this one only from those GCM already gave
      // click tags. A card can therefore show no check on a creative this
      // step lets past. Worth reconciling, but tightening the gate is a
      // behaviour change for every stepper, not a checkmark fix.
      validate() {
        let creativeList = Object.values(creatives.byId);

        for (let i = 0; i < creativeList.length; i++) {
          // Backups inherit taxonomy from primary — skip validation
          if (creativeList[i].creativeRole === "BACKUP") continue;
          // Existing DCM companions already have names from Campaign Manager
          if (creativeList[i].creativeRole === "COMPANION" && creativeList[i].file && creativeList[i].file.id) continue;

          if (!creativeList[i].taxonomy.name) {
            let label = creativeList[i].creativeRole === "COMPANION" ? "companion" : "primary";
            return {
              hasErrors: true,
              message: `You need to add naming for each ${label} asset.`
            };
          }
          
          if (
            creativeList[i].dcmCreative !== undefined &&
            creativeList[i].dcmCreative.hasOwnProperty("clickTags")
            ) {
            // continue, not return: rich media needs no URL, but returning
            // here ended validation for the whole batch, so an unnamed
            // creative anywhere after it passed unchecked.
            if (RMTypes.includes(creativeList[i].dcmCreative.type)) {
              continue;
            }
            if (!creativeList[i].dcmCreative.clickTags[0].clickThroughUrl) {
              return {
                hasErrors: true,
                message: "You need to set click through url for each asset."
              };
            }

            if (!creativeList[i].taxonomy.urlId) {
              return {
                hasErrors: true,
                message: "You need to set click through url for each asset."
              };
            }
          }

        }

        return {
          hasErrors: false,
          message: ""
        };
      }
    }));

    return (
      <React.Fragment>
        <Typography variant="h6" className={classes.h6}>
          Generate name/assign URL for each creative
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <HorizontalAssetList
              isClickEnabled={isClickEnabled}
              isDragDisabled={isDragDisabled}
              isThumbnailEnabled={isThumbnailEnabled}
              isWeightEnabled={false}
              groupByDimension={groupByDimension}
            />
          </Grid>
          <Grid item xs={6}>
            <Paper className={classes.paper2}>
              <CreativeNameManager
                standalone={false}
                advertiserId={advertiserId}
              />
            </Paper>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
);
